module.exports = __webpack_public_path__ + "static/WEDDING E&M-502-baa350a9fdf049d77ad68335ba282a17.jpg";